
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualizações',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Insira um número',
	'maxValuePlaceholder': 'Insira um número',
	'customRangeErrorMessage': 'O valor deve ser um número',
	'propFillColor': 'Cor de preenchimento',
	'propBorderColor': 'Cor da borda',
	'propColorPalette': 'Paleta de cores atuais',
	'propColorPaletteChangeLabel': 'Mudar paleta de cores',
	'propNewColorPaletteLabel': 'Crie uma paleta de cores customizada',
	'propNewHeatPaletteLabel': 'Criar uma paleta de calor customizada',
	'propDonutRadius': 'Raio de rosca',
	'showTitleLabel': 'Mostrar título',
	'titleTypeLabel': 'Tipo do título',
	'smartTitleLabel': 'Título inteligente',
	'customTitleLabel': 'Título customizado',
	'noTitleLabel': 'Sem título',
	'propHeatScalePalette': 'Paleta de calor atual',
	'propHeatPaletteChangeLabel': 'Alterar paleta de calor',
	'propMaintainAxisScales': 'Manter escala do eixo',
	'propLineAndSymbolColor': 'Cor de linha e símbolo',
	'propLineAndSymbolPalette': 'Paleta de cores de linhas e símbolos',
	'propElementColor': 'Cor do elemento',
	'propColumnColor': 'Cor da coluna',
	'propColumnPalette': 'Paleta de cores da coluna',
	'propColumnHeatPalette': 'Paleta de calor de coluna',
	'propBarColor': 'Cor da barra',
	'propGoalColor': 'Cor de destino',
	'propToColor': 'Para a cor',
	'propFromColor': 'Da cor',
	'propNumberValidationErrorMessageId': 'Inserir um número',
	'fontSizeAuto': 'Automático',
	'propAutoBinCount': 'Número de grupos',
	'propAutoBinToggle': 'Auto-agrupamento',
	'tabName_general': 'Geral',
	'tabName_visDetails': 'Detalhes',
	'tabName_animation': 'Animação',
	'tabName_mediaDetails': 'Detalhes de mídia',
	'tabName_webDetails': 'Detalhes da página da web',
	'tabName_imageDetails': 'Detalhes da Imagem',
	'tabName_visualization': 'Visualização',
	'tabName_text': 'Texto',
	'sectionName_colorsAndThemes': 'Cor e temas',
	'sectionName_appearance': 'Aparência',
	'sectionName_general': 'Geral',
	'sectionName_colorPalette': 'Cor',
	'sectionName_axis': 'Axis',
	'sectionName_axis_label': 'Axis',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Gráfico',
	'sectionName_regionLayer': 'Camada de regiões',
	'sectionName_pointLayer': 'Camada de pontos',
	'sectionName_latLongLayer': 'Camada de latitude/longitude',
	'sectionName_pathLayer': 'Caminho da camada',
	'propTransparencyDescription': 'Torne o objeto mais ou menos transparente. Digite um valor entre 0 e 100',
	'smart_annotation_unauthorized': 'Anotações: acesso não autorizado',
	'smart_annotation_method': 'Anotações: Método não permitido',
	'smart_annotation_media': 'Anotações: tipo de mídia não permitida',
	'smart_annotation_input': 'Anotações: entrada inválida',
	'smart_annotation_internal': 'Anotações: erro interno do sistema',
	'smart_annotation_generic_error': 'Anotações: Erro do serviço',
	'smart_annotation_dialog_title': 'Insights',
	'smart_errors': 'Erros de anotação:',
	'smart_warnings': 'Avisos de anotação:',
	'smart_annotation_insight_icon_title': 'Insights',
	'smart_annotations_toggle_on': 'Ativar insights',
	'smart_annotations_toggle_off': 'Alternar de insights',
	'smart_annotation_insight_unavailable': 'Os insights não estão disponíveis atualmente',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Os insights não estão disponíveis quando um filtro % Superior ou Inferior é aplicado',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'A previsão não está disponível ao aplicar um filtro % superior ou inferior',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Os insights não estão disponíveis quando um filtro superior ou inferior for aplicado e há mais de uma coluna no campo',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'A previsão não está disponível quando um filtro superior ou inferior é aplicado e há mais de uma coluna no campo',
	'forecast_title': 'Previsto',
	'forecast_toggle_on': 'Ativar previsão',
	'forecast_toggle_off': 'Desativar previsão',
	'statDetailsPerspectiveTitle': 'Análise',
	'emptyStatDetailsPanel': 'Nenhuma análise adicional está disponível para a visualização atual.',
	'predict_errors': 'Erros de análise',
	'predict_warnings': 'Avisos de análise',
	'fpd_invalid_data_source': 'Essa origem de dados não possui um módulo smarts associado',
	'fpd_network_issue': 'Houve um problema ao executar uma análise nessa origem de dados',
	'fpd_data_source_category': 'Módulo Smarts ausente',
	'fpd_response_errors': 'Erros Recomendados do Driver',
	'fpd_response_warnings': 'Avisos de driver recomendados',
	'catalyst_service_bad_request': 'Solicitação incorreta',
	'catalyst_service_unkown_Id': 'ID da solicitação desconhecido localizado',
	'catalyst_service_internal_server_error': 'Erro do Servidor Interno',
	'catalyst_service_generic_error': 'Erro de serviço de catalisador',
	'catalyst_service_error': 'Este serviço não está disponível atualmente',
	'propLegendPosition': 'Ranqueamento de legenda',
	'propLeft': 'Esquerda',
	'propRight': 'Direita',
	'propTop': 'Superior',
	'propBottom': 'Parte inferior',
	'propNone': 'Nenhum',
	'propLegendDisplay': 'Exibir legenda',
	'targetThicknessPlaceHolder': '%{min} a %{max}',
	'targetThicknessErrorMsg': 'Insira um número inteiro entre %{min} e %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Motoristas (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'Selecionado)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Reconfigurar para padrões',
	'possibelKeyDriver_AddNewDrivers': 'Inclua mais drivers',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Procurar para incluir mais drivers',
	'possibleKeyDrivers_MaxPossibleReached': 'Cancele a seleção de alguns drivers para inclusão ou selecione outros',
	'possibleKeyDrivers_Recommended': 'Recomendado',
	'visRecommendedTypes': 'Tipos de visualizações recomendadas',
	'visRecommender_smartsfailure': 'as recomendações de visualização não estão disponíveis atualmente',
	'visMore': 'Mais...',
	'visMoreTooltip': 'Mais visualizações',
	'visOtherTypes': 'Outros tipos de visualizações',
	'visChange': 'Alterar visualização',
	'automaticTypeCaption': 'Automática',
	'propVisType': 'Tipos de visualização',
	'dlg_loading': 'Carregando...',
	'snippetListChartCaption': 'Lista de fragmentos',
	'convoClusterChartCaption': 'Cluster de conversa',
	'areaChartCaption': 'Área',
	'barChartCaption': 'Barra',
	'columnChartCaption': 'Coluna',
	'stackedbarChartCaption': 'Barras empilhadas',
	'stackedcolumnChartCaption': 'Coluna empilhada',
	'bubbleChartCaption': 'Bolha',
	'marimekkoChartCaption': 'Marimekko.',
	'cometChartCaption': 'A análise do Driver',
	'scatterChartCaption': 'Dispersão',
	'lineChartCaption': 'Linha',
	'pointChartCaption': 'Ponto',
	'heatChartCaption': 'Mapa de calor',
	'bulletChartCaption': 'Marcador',
	'waterfallChartCaption': 'Queda D\'água',
	'pieChartCaption': 'Setor Circular',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Linha e coluna',
	'wordCloudChartCaption': 'Nuvem de palavras',
	'networkChartCaption': 'Rede',
	'relationshipNetworkChartCaption': 'Rede de Relacionamento',
	'treemapChartCaption': 'Mapa de árvore',
	'packedBubbleChartCaption': 'Bolhas compactadas',
	'hierarcicalPackedBubbleChartCaption': 'Hierarquia de bolha',
	'spiralChartCaption': 'Espiral',
	'decisionTreeChartCaption': 'Árvore de decisão',
	'legacyMapChartCaption': 'Mapa anterior',
	'sunburstChartCaption': 'Explosão Solar',
	'visUsageComparison': 'Comparação',
	'visUsageRelationships': 'Relacionamentos',
	'visUsageTrend': 'Tendência',
	'visUsagePartsToWhole': 'Peças para toda',
	'visUsageGeospatial': 'Geoespacial',
	'visUsageAdvanced': 'Analítica Avançada',
	'visUsageTablesAndSummary': 'Tabelas e resumo',
	'visUsageSocialInsights': 'Insights sociais',
	'visUsageOther': 'Outros',
	'autoBinActionText': 'Agrupamento automático',
	'filterAutobinActionText': 'Filtro de categorias',
	'memberCalculationActionText': 'Cálculo de membro',
	'toolbarActionCalculation': 'Cálculo',
	'toolbarActionEditCalculation': 'Editar cálculo',
	'topBottomRankLabel': 'Classificação (%{label})',
	'toolbarDeleteFilterActionText': 'Remover filtro',
	'toolbarActionTopKeyDrivers': 'Mostrar drivers',
	'toolbarActionCustomGroup': 'Grupo customizado',
	'canNotCreateCustomGroup': 'Não foi possível criar esse grupo customizado.',
	'aria_label_datatable': 'Tabela de dados',
	'summaryCaption': 'Resumo',
	'MeasuresCaption': 'Medidas',
	'MeasuresGroupCaption': 'Grupo de medidas (%{count})',
	'ValuesCaption': 'Valores',
	'turnInsightsOn': 'Ligar os insights',
	'turnInsightsOff': 'Desligar os insights',
	'decisionRules': 'Regras',
	'decisionTree': 'Diagrama de Árvore',
	'decisionSunburst': 'Explosão solar de árvore',
	'switchToDecisionRules': 'Mudar para regras de decisão',
	'switchToDecisionTree': 'Mudar para árvore de decisão',
	'data_group_less_then': 'inferior a %{rangeTo}',
	'data_group_to': '%{rangeFrom} até < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} e acima',
	'nullValueContent': '(sem valor)',
	'sum': 'Soma',
	'count': 'Contar',
	'countdistinct': 'Contagem distinta',
	'avg': 'Médio',
	'min': 'Mínimo',
	'max': 'Máximo',
	'automatic': 'Personalização',
	'variance': 'Variação',
	'stddev': 'Desvio Padrão',
	'median': 'Mediana',
	'calculated': 'Calculado',
	'none': 'Nenhum',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'O cenário do prompt não é suportado atualmente.',
	'preAggregateLabel': 'Aplicar valores de prompt da origem de dados',
	'postAggregateLabel': 'Aplicar valores de prompt no relatório',
	'preAggregateText': 'O intervalo usa os valores na origem de dados, não os valores exibidos no painel.',
	'defaultAggregation_count': 'Contar',
	'defaultAggregation_countdistinct': 'Contagem distinta',
	'defaultAggregation_max': 'Máximo',
	'defaultAggregation_min': 'Mínimo',
	'defaultAggregation_avg': 'Médio',
	'defaultAggregation_sum': 'Soma',
	'defaultAggregation_auto': 'Automático (%{aggregationType})',
	'keydriver_average': 'Média geral',
	'keydriver_up_down': 'Grupos destacados com médias altas ou baixas têm mais impacto no destino. Grupos com médias incomumente altas ou baixas têm o impacto mais forte.',
	'keydriver_different': 'Grupos destacados têm distribuições que diferem significativamente da distribuição geral. Esses grupos têm mais impacto no destino.',
	'topOperator': 'Superior',
	'bottomOperator': 'Parte inferior',
	'topBottomFact': '%{operator} %{value}%{percent} por %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Excluir contagem superior ou inferior',
	'deleteTopBottomPercent': 'Excluir % superior ou inferior',
	'topBottomTitle': 'Somente este objeto',
	'deleteTopBottom': 'Excluir contagem superior ou inferior',
	'editTopBottom': 'Editar contagem superior ou inferior',
	'editTopBottomCount': 'Editar contagem superior ou inferior',
	'editTopBottomPercent': 'Editar % superior ou inferior',
	'ariaDeleteTopBottomCountLabel': 'Pressione a tecla DELETE para excluir a contagem superior ou inferior.',
	'ariaDeleteTopBottomPercentLabel': 'Pressione a tecla DELETE para excluir a % superior ou inferior.',
	'ariaEditTopBottomCountLabel': 'Pressione a tecla ENTER para editar a contagem superior ou inferior.',
	'ariaEditTopBottomPercentLabel': 'Pressione a tecla ENTER para editar a % superior ou inferior.',
	'ariaDeleteDrillStateLabel': 'Pressione a tecla ENTER para editar a contagem superior ou inferior.',
	'drillUpStateTitle': 'Drill up',
	'drillDownStateTitle': 'Drill down',
	'ariaEditTopBottomLabel': 'Pressione a tecla ENTER para editar a contagem superior ou inferior.',
	'ariaDeleteTopBottomLabel': 'Pressione a tecla DELETE para excluir a contagem superior ou inferior.',
	'allKeyDriversLabel': 'Automático (todos os drivers)',
	'filter_drag_and_drop_single_dock': 'Arraste e solte dados aqui para filtrar.',
	'filter_drag_and_drop_all_tabs': 'Arraste e solte dados aqui para filtrar todas as guias.',
	'filter_drag_and_drop_current_tab': 'Arraste e solte dados aqui para filtrar esta guia.',
	'filter_empty_consume_mode': 'Nenhum filtro foi aplicado.',
	'filterClearAllItems': 'Limpar todos os filtros',
	'filterDeleteAllItems': 'Excluir todos os filtros',
	'filterDockChevronLeft': 'Percorra os dados',
	'filterDockChevronRight': 'Percorra os dados',
	'filterIconLabel_Single': 'Filtros',
	'filterIconLabel_Global': 'Todas as guias',
	'filterIconLabel_Tab': 'Essa guia',
	'filterIconTooltip_Single': 'Filtros',
	'filterIconTooltip_Global': 'Filtros para todas as guias',
	'filterIconTooltip_Tab': 'Filtros para esta guia',
	'filterDropZoneTooltip_Single': 'Zona de lançamento do filtro',
	'filterDropZoneTooltip_Global': 'Filtrar zona de lançamento para todas as guias',
	'filterDropZoneTooltip_Tab': 'Zona de lançamento do filtro para esta guia',
	'filterOverflowMenu': 'Mais',
	'expand': 'Expandir',
	'collapse': 'Reduzir',
	'filterDockItemNameAriaLabel': 'Pressione Enter para ativar o diálogo de filtro e definir o filtro.',
	'filterItemCanvasMove': 'Incluir nas telas',
	'filterItemDelete': 'Excluir filtro',
	'filterInvertRange': 'tudo, exceto: %{from}-%{to}',
	'filterRange': '%{from} - %{to}',
	'filter_date_after_except': 'Não após %{from}',
	'filter_date_after': 'Após %{from}',
	'filter_date_before_except': 'Não anterior a %{to}',
	'filter_date_before': 'Anterior a %{to}',
	'filter_date_between_except': 'Não entre %{from}-%{to}',
	'filter_date_between': 'Entre %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Todas',
	'filterExcept': 'exceto %{values}',
	'filterDockToolbarButtonLabel': 'Filtro de doca',
	'navigateTitle': 'Navegue para',
	'current_nav_group': 'O grupo atual de navegação é %{navigation_group_name}',
	'next': 'Próximo',
	'previous': 'Anterior',
	'multiselectMsg': '%{count} selecionados',
	'errMsgFilterItemMissingTitle': 'Não é possível carregar o(s) valor(es) de filtro %{itemName} porque ele(s) não está(ão) disponível(is) com esse conjunto de dados',
	'errMsgFilterItemGenericTitle': 'Valores de filtro não podem ser carregados',
	'textFilterItemsNotFound': 'Nenhum item está disponível.',
	'nullValueLabel': '(em branco)',
	'filterConditionLabel': 'Condição do Filtro',
	'filter_includesAll': 'Inclui todos',
	'filter_allMembersOfSet': 'Todos os membros do conjunto',
	'modelFilter': 'Filtrar',
	'filtersTitle': 'Propriedades do filtro',
	'search': 'Procurar',
	'clearTextFilterValue': 'Limpar',
	'invertFilterSelection': 'Inverter',
	'modellingLoading': 'Carregando...',
	'searchAll': 'Localizar todas as colunas',
	'toolbarActionPossibleKeyDrivers': 'Editar escopo',
	'toolbarActionPossibleKeyDriversSubTitle': 'Arrastar itens da esquerda para serem considerados no gráfico de análise do driver',
	'toolbarActionSort': 'Classificação',
	'toolbarActionSortAscending': 'Classificar Ascendente',
	'toolbarActionSortDescending': 'Classificar Decrescente',
	'toolbarActionSortAuto': 'Automático (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalização',
	'toolbarActionFormat': 'Formato',
	'toolbarActionFormatAbbreviation': 'Abbreviate',
	'toolbarActionFormatNone': 'Automático',
	'toolbarActionFilter': 'Filtrar',
	'toolbarActionTopBottom': 'Parte superior ou parte inferior',
	'toolbarActionRmvShape': 'Remover formato',
	'toolbarActionToggleShapeDrop': 'Forma do infográfico',
	'toolbarActionToggleShapeDropTitle': 'Criar um infográfico',
	'toolbarActionToggleShapeDropText': 'Arraste uma forma até este campo para criar um infográfico.',
	'toolbarActionAggregationType': 'Resumo',
	'toolbarDeleteActionText': 'Remover coluna',
	'toolbarTextActionText': 'Formatar texto',
	'toolbarActionFilterLocalKeepSelected': 'Manter',
	'toolbarActionFilterLocalExcludeSelected': 'Excluir',
	'toolbarActionFilterAllKeepSelected': 'Filtrar',
	'toolbarActionSimpleCalculation': 'Cálculo simples',
	'toolbarActionDrillBack': 'Voltar',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Navegar',
	'toolbarActionCreateFilterGroup': 'Criar nova conexão',
	'toolbarActionDisconnectFilterGroup': 'Quebrar todos os links',
	'toolbarActionLinkFilterGroup': 'Incluir em uma conexão existente',
	'toolbarActionLassoSelect': 'Selecionar ferramenta',
	'toolbarActionRefreshDeveloperWidget': 'Atualizar',
	'textFontFamilySubClassHairline': 'Fio',
	'textFontFamilySubClassThin': 'Fina',
	'textFontFamilySubClassThinItalic': 'Thin Itálico',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Itálico Light extra',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Itálico Claro',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Regular Itálico',
	'textFontFamilySubClassItalic': 'Itálico',
	'textFontFamilySubClassMedium': 'Média',
	'textFontFamilySubClassMediumItalic': 'Itálico Médio',
	'textFontFamilySubClassHeavy': 'Pesado',
	'textFontFamilySubClassHeavyItalic': 'Pesado Itálico',
	'textFontFamilySubClassDemiBold': 'Demi Negrito',
	'textFontFamilySubClassDemiBoldItalic': 'Demi Negrito Itálico',
	'textFontFamilySubClassBold': 'Negrito',
	'textFontFamilySubClassBoldItalic': 'Negrito Itálico',
	'textFontFamilySubClassExtraBold': 'Negrito Extra',
	'textFontFamilySubClassExtraBoldItalic': 'Itálico Negrito Extra',
	'textFontFamilySubClassBlack': 'Preto',
	'textFontFamilySubClassBlackItalic': 'Preto Itálico',
	'textFontFamilySubClassStencil': 'Estêncil',
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'descendente',
	'dlg_custom': 'customizado',
	'dlg_none': 'nenhum',
	'dlg_hierarchy': 'hierarchy',
	'dlg_namedSet': 'conjunto designado',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Remover identificador',
	'visualizationLabel': 'Visualização',
	'chartLabel': 'Gráfico %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pressione F12 para navegar no widget',
	'f10KeyDescription': 'Pressione F10 para ativar a visualização de foco do widget',
	'playButtonLabel': 'Executar',
	'dataPlayerValueListLabel': 'Valores do reprodutor de dados',
	'localFilterTitle': 'Somente este objeto',
	'globalFilterTitle': 'Todos os objetos',
	'deleteFilter': 'Excluir filtro',
	'editFilter': 'Editar Filtro',
	'ariaEditFilterLabel': 'Pressione a tecla ENTER para editar o filtro.',
	'ariaDeleteFilterLabel': 'Pressione a tecla DELETE para excluir o filtro.',
	'measureFilterBetween': 'Entre %{lowerBound} e %{upperBound}',
	'measureFilterNotBetween': 'Não entre %{lowerBound} e %{upperBound}',
	'dimFilterIn': 'Inclui: %{in}',
	'dimFilterNotIn': 'Exclui: %{out}',
	'gtFilter': 'Após %{lowerBound}',
	'ltFilter': 'Anterior a %{upperBound}',
	'ariaEditPrompt': 'Pressione a tecla ENTER para mudar o valor do prompt',
	'dataPointFilterTitle': 'Pontos de dados',
	'dataPointFilterIncludeSummary': '%{valueCount} pontos de dados incluídos',
	'dataPointFilterExcludeSummary': 'Excluídos %{valueCount} pontos de dados',
	'widgetFiltersLabel': 'Filtros do widget',
	'coachMarkTitleSpiralTarget': 'Editar escopo',
	'coachMarkContentSpiralTarget': 'Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Locais não reconhecidos:',
	'geomapAmbiguousLocations': 'Regiões ambíguas:',
	'visualizationNotifications': 'Visualização de notificações:',
	'dataNotifications': 'Notificações de dados:',
	'autobinSuggestion': 'Ative o auto-agrupamento',
	'LIVE_empty_visualization_hint_title': 'Construa sua visualização',
	'LIVE_empty_visualization_hint_description': 'Arraste os dados para cá ou para os campos.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica um campo obrigatório',
	'LIVE_slots_drag_and_drop_description': 'Arraste e solte dados para os campos acima para criar e filtrar a visualização.',
	'dwErrorLoadingAvailableVisualizations': 'Não é possível carregar as definições de visualização disponíveis',
	'moreDataIndicator': 'Seus dados foram cortados em  %{threshold} itens. Aplique um filtro para mostrar menos.',
	'nonCtxTopBottomInvalid': 'A definição de uma regra superior ou inferior sem um contexto não é suportada para crosstabs. Ele foi removido dessa visão de crosstab.  Redefina a regra em uma ou mais categorias no contexto de %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Não foi possível carregar o objeto porque havia uma definição de visualização ausente.',
	'dwErrorLoadingVisualizationListNotFound': 'Nós podemos  \'t carregar a visualização.',
	'dwErrorRunningQuery': 'Não foi possível recuperar os dados do conjunto de dados %{datasetName}.',
	'dwErrorGeoData': 'Ocorreu um problema ao exibir os dados geográficos em um mapa. Escolha outro tipo de visualização.',
	'dwPromptSignonCancelWarning': 'Os dados para esta visualização estão indisponíveis. Forneças as credenciais corretas.',
	'dwErrorMissingDataset': 'Não foi possível carregar a visualização porque seu conjunto de dados associado \'%{datasetName}\' não está disponível.',
	'dwErrorRenderingVisualization': 'Não é possível carregar essa visualização.',
	'dwErrorVisualizationTooSmall': 'A visualização é muito pequena para exibir os dados que ela contém. Torne a visualização maior ou limite os dados que ela contém.',
	'errorSourceNotFound': 'Não foi possível carregar a visualização porque sua origem associada \'%{sourceName}\' não está disponível.',
	'errorActionNotSupported': 'Essa ação não é suportada para a origem de dados \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'A visualização possui medidas em diversas bordas, que não são mais suportadas. Coloque as medidas em apenas uma extremidade.',
	'errorExceedAllowableValue': 'O número estimado de células excede o valor permitido de 100000. Aplique a filtragem em conjuntos projetados para reduzir o número de células.',
	'propScaleLabel': 'Quantidade de ícones',
	'propScaleDescription': 'Selecione a quantidade de ícones',
	'propScaleFew': 'Baixa',
	'propScaleDefault': 'Padrão',
	'propScaleMany': 'Alta',
	'lastRefresh': 'Última atualização: há %{timeInterval}',
	'widgetTimer': 'Cronômetro do widget',
	'datasetItemsUnavailable': 'Alguns itens do conjunto de dados usados nesta visualização estão indisponíveis.',
	'datasetItemUnavailable': 'Este item do conjunto de dados está indisponível',
	'retry': 'Tentar novamente',
	'widgetConditionalFormatLabel': 'Alternar controles de formato condicional',
	'widgetConditionalFormatTitle': 'Editar cor da formatação condicional',
	'conditionalPalettePickerLabel': 'Distribuição de %{title} valores',
	'HistogramYAxisTitle': 'Contar',
	'crosstabName': 'Tabela cruzada',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/C',
	'summaryLabel': '%{label} com o valor %{value}',
	'infographicLabel': '%{label} com o valor %{value}',
	'warning': 'Aviso',
	'swapRowsAndColumns': 'Trocar linhas e colunas',
	'hideSummariesLabel': 'Ocultar resumos',
	'showSummariesLabel': 'Mostrar resumos',
	'hideRowColumn': 'Ocultar',
	'showAllRowColumn': 'Mostrar tudo',
	'dataAssetPropertiesLabel': 'Propriedades de visualização',
	'evAdd': 'Incluir uma coluna',
	'evCollapse': 'Reduzir',
	'evColumns': 'Colunas',
	'evLocalFilters': 'Filtros locais',
	'evExpand': 'Expandir',
	'evFilterTooltip': 'Filtrar',
	'missingColumn': 'Ausente: %{columnLabel}',
	'missingFiltering': 'Os filtros ausentes em colunas:',
	'missingDataItem': 'O item de dados referenciado \'%{dataItemId}\' não foi localizado no widget.',
	'heatByLabel': 'Utilização por',
	'toolbarChangeVisualization': 'Alterar visualização',
	'modellingRelatedTablesNoneFound': 'Nenhuma tabela relacionada localizada',
	'processing': 'Processando...',
	'errorCellWarning': 'Não foi possível calcular alguns valores de resumo.',
	'aggregateTypeToggler': 'Mostrar tipo de agregação',
	'maxColumnsExceeded': 'Número máximo de colunas excedido. %{columns} caiu.',
	'unboundColumns': 'Não é possível usar as seguintes colunas: %{columns}.',
	'unboundColumn': 'Não é possível usar a coluna a seguir: %{columns}.',
	'recommendRequestFailed': 'Falha na solicitação de recomendação. Entre em contato com o administrador.',
	'visualizationDoesNotSupportOLAP': 'Não é possível criar a visualização com base em uma origem de dados OLAP. Use outra origem de dados suportada.',
	'showDataBehindVizLabel': 'Mostrar dados',
	'showDataBehindVizNotSupportedLabel': 'Mostrar dados não é suportado para esse tipo de visualização',
	'exploreData': 'Explorar ...',
	'newExplore': 'Nova exploração',
	'thumbnails_error_fetching': 'Erro ao buscar as miniaturas',
	'loadedThumbnailImage': 'Imagem miniatura da visualização %{visType} carreada',
	'autobinAxisLabel': 'grupos',
	'recommended_visualizations': 'Visualizações Recomendadas',
	'all_visualizations': 'Todas as visualizações',
	'edit': 'Editar',
	'selectTargetDialogTitle': 'Selecione um destino de drill through',
	'noTargetInCM': 'Não é possível localizar o destino do drill through',
	'errorDrillDefinition': 'Ocorreu um problema ao incluir ou editar a definição de drill through.',
	'errorDrillToTarget': 'Ocorreu um erro ao fazer drill para \'%{targetName}\'',
	'drillThroughMappingViewLabel': 'Designe colunas de seu painel para os avisos do relatório de destino',
	'drillthroughScopeRadioLabel': 'Aplicar esta definição em:',
	'drillthroughScopeRadioOptionVisualization': 'Somente esta visualização',
	'drillthroughScopeRadioOptionConnection': 'Visualizações na mesma conexão que usam a mesma origem de dados',
	'drillthroughScopeRadioOptionDashboard': 'Qualquer visualização no %{perspective} que usa a mesma origem de d drillThroughDefinitionNoParameter \\= O destino de drill-through não tem avisosados',
	'drillThroughParametersColumnTitle': '\'%{targetName}\' avisos:',
	'drillThroughMetadataColumnTitle': 'Colunas de dados \'%{boardName}\':',
	'drillThroughDefinitionNoParameter': 'O destino de drill-through não tem avisos.',
	'drillThroughDefinitionErrorQueryingReport': 'Corrija o problema com o relatório de destino e, em seguida, tente criar novamente a definição de drill through.',
	'drillThroughDefinitionErrorDlgTitle': 'Algo deu errado.',
	'dlg_back': 'Voltar',
	'dlg_close': 'Fechar',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Cancelar',
	'dlg_apply': 'Aplicar',
	'drillthrough_unsaveMsg': 'Continuar sem salvar \'%{name}\'?',
	'drillthrough_jumpTo': 'Definição de drill through: %{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Gerenciar...',
	'drillthrough_addNewTarget': 'Inclua uma nova definição de drill through',
	'drillthrough_manageJumpPaths': 'Gerenciar definições de drill through',
	'drillthrough_manageJumpPaths_edit': 'Editar \'%{name}\'',
	'drillthrough_manageJumpPaths_delete': 'Excluir \'%{name}\'',
	'drillthrough_manageAddAnotherTarget': 'Incluir outra definição de drill through',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirmar Exclusão',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Tem certeza de que deseja excluir o drill through \'%{name}\'?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplicar o nome do drill through',
	'drillthrough_definitionMessage': 'O drill through \'%{name}\' já existe. Forneça um nome diferente',
	'drillthrough_jumpToTarget_notFound': 'Destino não localizado para o drill through \'%{name}\'',
	'drillThroughDefinitionNoParameterSubTitle': 'Nenhum contexto será transmitido para o relatório de destino.',
	'drillthrough_titleLabel': 'Título',
	'drillthrough_subTitle': 'O contexto da visualização em sua origem é usado para filtrar o %{perspective} de destino.',
	'noPrompt': 'Nenhum prompt',
	'formatAutoDescription': 'Automático especifica o formato herdado de sua origem de dados ou visualização.',
	'formatDefaultDescription': 'Padrão especifica o formato herdado do sistema',
	'createCustomGroupAction': 'Crie um grupo de dados',
	'removeCustomGroupAction': 'Remova o grupo de dados',
	'editCustomGroupAction': 'Editar grupo de dados',
	'renameCustomGroupAction': 'Renomeie o grupo de dados',
	'createCustomGroupErrorToast': 'Não foi possível criar seu grupo de dados.',
	'removeCustomGroupErrorToast': 'Não foi possível remover seu grupo de dados.',
	'editCustomGroupErrorToast': 'Não foi possível editar seu grupo de dados.',
	'renameCustomGroupErrorToast': 'Não foi possível renomear seu grupo de dados.',
	'customGroupLabel': 'Grupo de dados',
	'ungroupCustomGroupLabel': 'Desagrupar',
	'renameCustomGroupLabel': 'Renomear',
	'createCustomGroupLabel': 'Criar',
	'customGroupingLabel': '%{columnLabel} (Grupo)',
	'createCustomSort': 'Criar classificação customizada',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Selecione os itens disponíveis e, em seguida, reordene-os para criar uma classificação customizada.',
	'availableItems': 'Itens disponíveis',
	'selectAll': '(Selecionar todos)',
	'customSortOrder': 'Ordem de Classificação Personalizada',
	'selectAvailableItemsDesc': 'Selecione os itens disponíveis e reordene-os aqui.',
	'moveToTop': 'Mover para a primeira posição',
	'clear': 'Limpar',
	'sortRemainingItemsBy': 'Classificando itens restantes por',
	'clearAll': 'Limpar tudo',
	'resetTooltip': 'Todos os itens serão removidos da lista %{customSortOrder} e o menu suspenso de %{sortRemainingItemsBy} será revertido para o padrão.',
	'manyItemsWarning': 'Selecionar muitos itens pode afetar o desempenho de seu painel.',
	'manyItemsSelected': 'Mais de %{maxItems} itens foram selecionados, o que pode afetar o desempenho de seu painel.',
	'somethingWentWrong': 'Algo deu errado.',
	'unableToLoadItems': 'Não é possível carregar os itens disponíveis.',
	'tryAgain': 'Tentar novamente',
	'customSortLabel': 'Classificação customizada',
	'applyError': 'Não é possível aplicar %{action}.',
	'searchReturnedNoResults': 'Sua pesquisa não teve nenhum resultado',
	'tryDifferentSearchTerm': 'Tente um termo de procura diferente',
	'extVisSystem': 'Sistema',
	'extVisCustom': 'Personalização',
	'customVisTestVisualization': 'Visualização de teste',
	'extVisCustomVisPreview': 'pré-visualizar',
	'extVisCustomPreviewWidgets': 'Widgets do desenvolvedor',
	'extVisCustomVVisualization': 'Visualização',
	'extVisCustomVisuals': 'Visualizações customizadas',
	'noPermissionToManage': 'Você não tem permissão para gerenciar visualizações customizadas.',
	'extVisCustomUpdate': 'Atualizar',
	'extVisCustomDelete': 'Excluir',
	'extVisNoCustomVisuals': 'Nenhum visual customizado',
	'extVisNoCustomVisualsMsg': 'Não há visuais customizados atualmente em sua organização',
	'extVisAddCustomVisual': 'Incluir um visual customizado',
	'extVisNoCustomVisualsAdminMsg': 'Não há atualmente visuais customizados. Inclua um para iniciar',
	'extVisNoSDKConnection': 'Nenhuma conexão foi criada para seu arquivo local',
	'extVisNoSDKPreviewMsg': 'Para visualizar suas visualizações, estabeleça uma conexão.',
	'extVisMore': 'Mais',
	'extVisDeleteDialogTitle': 'Excluir visual customizado',
	'extVisDeleteDialogBody': 'Tem certeza de que deseja excluir essa visualização customizada? Ela pode estar em uso por outros painéis e relatórios.',
	'extVisDeleteConfirmation': 'Seu visual customizado foi excluído.',
	'extVisDeleteError': 'Seu visual customizado não pôde ser excluído. %{msg}',
	'extVisCloseToast': 'Fechar agora',
	'extVisAdd': 'Seu visual customizado foi incluído com êxito.',
	'extVisAddError': 'Seu visual customizado não pôde ser incluído. %{msg}',
	'extVisUpdate': 'Seu visual customizado foi atualizado com êxito.',
	'extVisUpdateError': 'Seu visual customizado não pôde ser atualizado. %{msg}',
	'extVisAddProgress': 'Importando %{name}',
	'extVisUpdateProgress': 'Atualizando %{name}',
	'extPermissionTitle': 'Acesso restrito ou visual customizado excluído',
	'extPermissionBody': 'Esse visual customizado não pode ser visualizado porque ele foi excluído ou tem acesso restrito.',
	'customVizSaveWarning': 'Suas visualizações customizadas não podem ser salvas. Elas não foram importadas.',
	'schematicTestCaption': 'Teste esquemático',
	'schematicServiceRequestError': 'Erro de serviço esquemático',
	'extVisPreviewMessage': 'Esta é uma visualização. A visualização ainda não foi incluída no produto.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Indefinido',
	'kpiDefaultTargetLabel': 'Destino',
	'kpiNonNumericTarget': 'O valor de destino deve ser um número.',
	'kpiManualTargetSlotFilled': 'Valor aplicado no campo',
	'kpiAutoValueSize': 'Automático',
	'kpiUnableDrawSparklineLabel': 'Não é possível desenhar gráficos de linhas',
	'kpiUnableDrawSparklineInfo': 'Um gráfico de linhas requer um mínimo de dois pontos no tempo. Mude os dados ou ajuste os filtros para ver o gráfico de linhas.',
	'conditionalFormattingEnabled': 'Cor condicional',
	'currentConditionalPalette': 'Paleta condicional atual',
	'sectionName_range': 'Configurar o intervalo',
	'rangeScaleLabel': 'Escala',
	'rangeScalePercentage': 'Percentual',
	'rangeScaleNumeric': 'Numérico',
	'numberOfSteps': 'Número de intervalos',
	'conditionalFormattingSelectedStep': 'Intervalo selecionado',
	'conditionalFormattingStartValue': 'Valor inicial',
	'conditionalFormattingEndValue': 'Valor final',
	'conditionalFormattingTextColor': 'Cor do texto',
	'conditionalFormattingMin': 'Mín',
	'conditionalFormattingMax': 'Máx',
	'conditionalFormattingNonNumericValue': 'O valor deve ser um número.',
	'conditionalFormattingStepIndexInvalid': 'O índice de intervalo é inválido.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'O valor deve estar no intervalo de %{start} a %{end}.',
	'conditionalFormattingValueShouldBeLower': 'O valor deve ser menor ou igual a %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'O valor deve ser maior ou igual a %{value}.',
	'conditionalFormattingDeleteStep': 'Remover intervalo selecionado',
	'conditionalFormattingRestoreSteps': 'Restaurar intervalos',
	'conditionalFormattingReversePalette': 'Cores reversas',
	'conditionalFormattingShapeIndicator': 'Forma do indicador',
	'conditionalFormattingIconNone': 'Sem forma',
	'conditionalFormattingIconArrowUp': 'Seta para cima',
	'conditionalFormattingIconArrowRight': 'Seta para a direita',
	'conditionalFormattingIconArrowDown': 'Seta para baixo',
	'conditionalFormattingIconCaretUp': 'Indicador para cima',
	'conditionalFormattingIconDash': 'Travessão',
	'conditionalFormattingIconCaretDown': 'Indicador para baixo',
	'conditionalFormattingIconCheckmark': 'Marca de seleção',
	'conditionalFormattingIconWarning': 'Aviso',
	'conditionalFormattingIconXSymbol': 'Símbolo X',
	'conditionalFormattingIconCircle': 'Círculo',
	'conditionalFormattingIconTriangle': 'Triângulo',
	'conditionalFormattingIconDiamond': 'Losango',
	'conditionalFormattingIconFaceSatisfied': 'Expressão de satisfeito',
	'conditionalFormattingIconFaceNeutral': 'Expressão neutra',
	'conditionalFormattingIconFaceDissatisfied': 'Expressão de insatisfeito',
	'suppression': 'Supressão',
	'suppressNone': 'Nenhum',
	'suppressRowsAndColumns': 'Linhas e colunas',
	'suppressRows': 'Linhas',
	'suppressColumns': 'Colunas',
	'enableSuppression': 'Ativar supressão',
	'disableSuppression': 'Desativar supressão',
	'loadVisDefinitionError': 'Não foi possível carregar a definição para a visualização %{id}',
	'emptyVisualization': 'Visualização vazia',
	'expandCollapse': 'Expandir e reduzir',
	'expandBtnLabel': 'Expandir',
	'collapseBtnLabel': 'Reduzir',
	'prop_sizeInputNonNumericValue': 'O valor deve ser um número.',
	'prop_sizeValueShouldBeHigher': 'O valor deve ser maior que %{value}.',
	'fontPropLabel': 'Família de fontes',
	'fontSizePropLabel': 'Tamanho de fonte',
	'sectionItemAxisTitle': 'Título do eixo do item',
	'sectionItemAxisLabel': 'Rótulo do eixo do item',
	'sectionValueAxisTitle': 'Título do eixo de valor',
	'sectionValueAxisLabel': 'Rótulo do eixo de valor',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualização',
	'ds-missingDataSet': 'Não foi possível localizar o dataset. Certifique-se de que o dataset é criado com sucesso.',
	'ds-missingDashboardId': 'Salve o painel antes de criar o conjunto de dados.',
	'ds-unsupportedDataSourceType': 'O tipo de origem de dados %{type} não é suportado.'
});
